import { render, staticRenderFns } from "./PropertyFilter.vue?vue&type=template&id=5e8a2a35&"
import script from "./PropertyFilter.vue?vue&type=script&lang=js&"
export * from "./PropertyFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports